<template>
	<div class="echarts-box">
		<div ref="echartRef" class="charts" ></div>
	</div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount, watch, nextTick, markRaw, defineProps, defineEmits, defineExpose } from 'vue';
import * as echarts from 'echarts';
import 'echarts-gl';


const props = defineProps({
	// 图表配置
	data: {
		type: Object,
		default: () => {},
	},
});

const echartRef = ref();

let dom = null;

//设置图表配置
const setOptions = (options) => {
	//清除画布
	dom && dom.clear();
	//重新渲染
	dom && dom.setOption(options);
};

watch(
	() => props.data,
	(val) => {
		nextTick(() => {
			//默认关闭动画
			setOptions({animation: false,...val});
		});
	},
	{ deep: true, immediate: true }
);
const emits = defineEmits(['click'])
onMounted(() => {
	//初始化
	dom = markRaw(echarts.init(echartRef.value));
	//点击事件
    dom.on('click', (param)=> {
		// emits('click',param)
	})
});
onBeforeUnmount(() => {
	//离开销毁
	echarts.dispose(dom);
	dom = null;
});
defineExpose({
	setOptions,
});
</script>
<style lang="scss" scoped>
.echarts-box {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	.charts {
		width: 100%;
		height: 100%;
		div:nth-child(2) {
			background-color: aquamarine !important;
		}
	}
}
</style>
<style lang="scss">
.echarts-box .charts div:nth-child(2) {
	background-color: transparent !important;
	border: none !important;
	opacity: 1 !important;
	transform: translate3d(2vw, -1vw, -0px) !important;
	box-shadow: none !important;
}
.tooltip-box {
	width: 252px;
	height: 120px;
	margin-right: 5px;
	border-radius: 10px;
    background-image: url("@/assets/left-bt-bg.png");
	background-size: 100% 100%;
  	background-position: center;
	// border: 1px solid #fff;
	.number {
		width: 100%;
		height: 30px;
		line-height: 30px;
		font-weight: bold;
		font-size: 24px;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
		position: relative;
		top: 5px;
	}
	.name {
		width: 100%;
		height: 30px;
		line-height: 60px;
		text-align: center;
		font-size: 16px;
		color: #FFFFFF;
	}
}
</style>